import React, { FC } from 'react'

import { Text, TextName } from 'sdk'
import { Button } from 'sdk/button/Button'
import { AccelerationCards } from '../../components/acceleration-cards/AccelerationCards'

import classes from './style.module.scss'

export const AccelerationSection: FC = () => {
  return (
    <div className={classes.container}>
      <Text type={TextName.H2} className={classes.title}>
        A Technological First: GPU Acceleration For Audio
      </Text>

      <AccelerationCards />

      {/* <Button as="button" onClick={() => console.log('Open popup')}>
        Learn More
      </Button> */}
    </div>
  )
}
